import React, { useState, useMemo } from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'

/**
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.value
 * @param {function} props.onChange
 * @param {{ value: string, label: string }[]} props.options
 * @param {object} [props.formControlProps]
 */
const SearchableSelect = ({ label, value, onChange, options, formControlProps = {} }) => {
  const [search, setSearch] = useState('')

  const filtered = useMemo(() => {
    const q = search.toLowerCase()
    return q ? options.filter((o) => o.label.toLowerCase().includes(q)) : options
  }, [search, options])

  return (
    <FormControl fullWidth {...formControlProps}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        onClose={() => setSearch('')}
        MenuProps={{ autoFocus: false }}
      >
        <ListSubheader sx={{ pt: 1, pb: 0.5 }}>
          <TextField
            size="small"
            fullWidth
            autoFocus
            placeholder="Search…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </ListSubheader>
        {filtered.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SearchableSelect
